import * as angular from "angular";
import {IController} from "angular";
import {AdditionType} from "../../types/addition.type";

export class AdditionTypeSelectCtrl implements IController {

  type: AdditionType;
  isDisabled: boolean;
  isRequired?: string;
  ngPlaceholder?: string;
  noUnderline?: string;
  onChange: Function;

  public selectOptions: AdditionType[];

  /* @ngInject */
  constructor(private pricePlanConstant, private $mdSelect) {
    this.selectOptions = this.pricePlanConstant.additionTypes;
  }

  reset() {
    this.onChange({type: undefined});
    this.$mdSelect.hide();
  }

  cancel() {
    this.$mdSelect.hide();
  }

  select() {
    this.onChange({type: this.type});
    this.$mdSelect.hide();
  }

}



angular
  .module('bringoz.admin.pricePlan')
  .component('additionTypeSelect', {
    require: {
      form: '?^form'
    },
    bindings: {
      type: '<',
      isDisabled: '<?',
      isRequired: '@?',
      ngPlaceholder: '@?',
      noUnderline: '@?',
      onChange: '&'
    },
    template: require('./addition-type-select.html').default,
    controller: AdditionTypeSelectCtrl
  });

